/* eslint-disable @typescript-eslint/no-explicit-any */
import { datadogLogs } from '@datadog/browser-logs'

import { Logger } from './types'
import { isAxiosError } from 'axios'
import { buildAxiosErrorContext } from '../helpers/buildAxiosErrorContext'

export class ClientSideLogger implements Logger {
  private readonly isCollecting: boolean

  constructor(collectLogs: boolean) {
    this.isCollecting = collectLogs
  }

  setMetadata<T extends object>(metadata: T) {
    datadogLogs.logger.setContext(metadata)
  }

  info(message: string, context?: any): void {
    if (this.isCollecting) {
      datadogLogs.logger.info(message, context)
    } else {
      console.info(message, { context })
    }
  }

  warn(message: string, context?: any, error?: Error): void {
    if (this.isCollecting) {
      datadogLogs.logger.warn(message, context, error)
    } else {
      console.warn(message, { context }, error)
    }
  }

  error(message: string, context?: any, error?: Error): void {
    const axiosErrorContext = isAxiosError(error)
      ? { requestContext: buildAxiosErrorContext(error) }
      : {}

    const contextToSend = { ...context, ...axiosErrorContext }

    if (this.isCollecting) {
      datadogLogs.logger.error(message, contextToSend, error)
    } else {
      console.error(message, { context: contextToSend }, error)
    }
  }
}
